import { Expense } from "@finway-group/shared/lib/models"
import { DatePicker } from "antd"
import moment from "moment"
import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { NotificationService } from "../../../../../shared/services"
import { patchExpense } from "../../../../../shared/store/actions/expense/expenseActions"
import { formatExpenseDate } from "../../../../../shared/utils/date.utils"
import { getPopupAnchor } from "../../../../../shared/utils/popup.utils"

interface InvoiceDueDateFieldProps {
    expense: Expense
    setIsExpenseUpdating?: React.Dispatch<React.SetStateAction<boolean>>
    areInputsDisabled: boolean
    shouldShowInvoiceFields: boolean
    isInvoiceFieldRequired: boolean
    paymentTerm?: number
}

export const InvoiceDueDateField = ({ expense, setIsExpenseUpdating, areInputsDisabled, shouldShowInvoiceFields }: InvoiceDueDateFieldProps) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const invoiceDueDate = expense.invoiceDueDate ? moment(expense.invoiceDueDate) : undefined

    const onInvoiceDueDateUpdate = async (invoiceDueDate: any) => {
        try {
            setIsExpenseUpdating?.(true)
            await patchExpense(expense.id, { invoiceDueDate })(dispatch)
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:request.edit.title"))
        } finally {
            setIsExpenseUpdating?.(false)
        }
    }

    if (shouldShowInvoiceFields) {
        return (
            <li>
                <span className={`w-1/2 title `}>{t("label:invoice_due_date")}</span>
                <DatePicker
                    className="w-1/2"
                    value={invoiceDueDate}
                    format={moment.localeData().longDateFormat("L")}
                    placeholder={t("placeholder:request.date")}
                    onChange={onInvoiceDueDateUpdate}
                    getPopupContainer={getPopupAnchor()}
                    disabled={areInputsDisabled}
                />
            </li>
        )
    }

    if (!expense.invoiceDueDate) {
        return null
    }

    return (
        <li>
            <span className="title">{t("label:invoice_due_date")}</span>
            <span className="text">{formatExpenseDate(expense.invoiceDueDate)}</span>
        </li>
    )
}
